module.exports = __webpack_public_path__ + "img/top_section_bcg.2c5e2cd2.jpg";